module.exports = __webpack_public_path__ + "static/media/Vliegtuig_in_de_lucht.311b3552.mp3";